// extracted by mini-css-extract-plugin
export default {"settingsContainer":"Settings_settingsContainer__3HyTy","settingsFormsContainer":"Settings_settingsFormsContainer__DjiF3"};